<div *ngIf="!performanceTableData$" class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50">
  <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
</div>
<ng-container *ngIf="performanceTableData$ as ki">
  <div class="flex w-full items-center justify-end pr-4">
    <span class="text-sm font-medium justify-end text-gray-700" [class.invisible]="activeTab$ !== 'calendar'">
      Visualize more years
    </span>
    <button [disabled]="visibleYearsStartIndex<=0" class="p-1 text-2xl font-bold  "
      [class.invisible]="activeTab$ !== 'calendar'" (click)="scrolllVisibleYears(-1)">
      < </button>
        <button [disabled]="visibleYearsStartIndex>=yearsSet.size-6" class="p-1  text-2xl font-bold"
          [class.invisible]="activeTab$ !== 'calendar'" (click)="scrolllVisibleYears(+1)">
          >
        </button>
  </div>
  <p-table [value]="ki" [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" [first]="first"
    [sortField]="defaultSortField" [sortOrder]="defaultSortOrder" class="home-performance-table"
    [tableStyle]="{ 'min-width': '50rem' }" (onSort)="onSortChange($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries{{isFilterApplied ? ` (filtered from ${totalRecordsCount} total entries)` : ''}}"
    stripedRows="" sortMode="single">
    <ng-template #header>
      <tr class="bg-bnpp-green text-white">
        <th pSortableColumn="technicalName" style="width:13%">
          Index Name
          <p-sortIcon field="technicalName"></p-sortIcon>
        </th>

        <!-- Bloomberg Code -->
        <th pSortableColumn="bloombergCode" style="width:13%">
          Bloomberg Code
          <p-sortIcon field="bloombergCode"></p-sortIcon>
        </th>

        <!-- Asset -->
        <th pSortableColumn="asset" style="width:7%">
          Asset
          <p-sortIcon field="asset"></p-sortIcon>
        </th>

        <!-- Style -->
        <th pSortableColumn="secondLevel" style="width:7%">
          Style
          <p-sortIcon field="secondLevel"></p-sortIcon>
        </th>

        <!-- Geography -->
        <th pSortableColumn="geography" style="width:6%">
          Geography
          <p-sortIcon field="geography"></p-sortIcon>
        </th>

        <!-- Type -->
        <th pSortableColumn="type" style="width:6%">
          Type
          <p-sortIcon field="type"></p-sortIcon>
        </th>

        <!-- Currency -->
        <th pSortableColumn="mdsCurrencyCode" style="width:5%">
          Currency
          <p-sortIcon field="mdsCurrencyCode"></p-sortIcon>
        </th>

        <!-- Last Update Date -->
        <th pSortableColumn="formattedLastUpdateDate" style="width:7%">
          Last Update Date
          <p-sortIcon field="formattedLastUpdateDate"></p-sortIcon>
        </th>

        <!-- Index Level -->
        <th pSortableColumn="indexLevel" style="width:6%">
          Index Level
          <p-sortIcon field="indexLevel"></p-sortIcon>
        </th>

        <!-- YTD Return -->
        <th pSortableColumn="perfYTD" style="width:5%">
          YTD Return
          <p-sortIcon field="perfYTD"></p-sortIcon>
        </th>
        <ng-container *ngFor="let year of visibleHeaders">
          <th [pSortableColumn]="getVisibleYearHeaderKey(year)" style="width:5%">
            {{ year }}
            <p-sortIcon [field]="getVisibleYearHeaderKey(year)"></p-sortIcon>
          </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template #body let-performance>
      <tr>
        <td> <a [routerLink]="['/index']" [queryParams]="{ mdsCode: performance.mdsCode }">{{ performance.technicalName
            }}</a></td>
        <td>{{ performance.bloombergCode }}</td>
        <td>{{ performance.asset }}</td>
        <td>{{ performance.secondLevel }}</td>
        <td>{{ performance.geography }}</td>
        <td>{{ performance.type }}</td>
        <td>{{ performance.mdsCurrencyCode }}</td>
        <td>{{ performance.formattedLastUpdateDate }}</td>
        <td [ngClass]="getReturnClass((performance.indexLevel ?? 0))">{{ performance.indexLevel }}</td>
        <td [ngClass]="getReturnClass((performance.perfYTD ?? 0))">{{ performance.perfYTD }}</td>
        <ng-container *ngFor="let header of visibleHeaders">
          <td [ngClass]="getReturnClass(getVisibleYearData(header, performance) ?? 0)">
            {{ getVisibleYearData(header, performance) }}
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</ng-container>